export var Labels = {
    paymentProcessing: '支払処理' //TODO: Confirm translation
};
